import { handleActions } from 'redux-actions';

import actions from 'state/salesIntelligence/actionCreators';
import initialState from 'state/salesIntelligence/initial.state';

const salesIntelligenceReducer = handleActions(
  {
    [actions.setRecurringOrderSuggestion]: (
      state,
      { payload: { suggestion } }
    ) => ({
      ...state,
      recurringOrderSuggestion: suggestion,
    }),
    [actions.openRecurringOrderSuggestionsModal]: (state) => ({
      ...state,
      ui: {
        ...state.ui,
        suggestionsModalOpened: true,
      },
    }),
    [actions.closeRecurringOrderSuggestionsModal]: (state) => ({
      ...state,
      ui: {
        ...state.ui,
        suggestionsModalOpened: false,
      },
    }),
    [actions.openRecurringOrderSuggestionsDiscardReasonsModal]: (state) => ({
      ...state,
      ui: {
        ...state.ui,
        suggestionsDiscardReasonsModalOpened: true,
      },
    }),
    [actions.closeRecurringOrderSuggestionsDiscardReasonsModal]: (state) => ({
      ...state,
      ui: {
        ...state.ui,
        suggestionsDiscardReasonsModalOpened: false,
      },
    }),
  },
  initialState
);

export default salesIntelligenceReducer;
